
import { DirectionEnum, PassengerTypeEnum } from "@/models/enums";
import { useBookingStore } from "@/store/booking";
import { computed, defineComponent } from "vue";
import TripPassengerSelect from "../bookingflow/steps/tripdetails/TripPassengerSelect.vue";
import QuickformInput from "./QuickformInput.vue";

export default defineComponent({
	components: {
		TripPassengerSelect,
		QuickformInput,
	},
	setup() {
		const bookingStore = useBookingStore();

		const passengerCount = computed(() => {
			const passengers = bookingStore.getPassengers(DirectionEnum.Outward);

			const passengerCount = passengers.filter(
				(p) => p.type !== PassengerTypeEnum.Dog
			).length;
			const dogCount = passengers.filter(
				(p) => p.type === PassengerTypeEnum.Dog
			).length;

			if (dogCount < 1) {
				return `${passengerCount} passengers`;
			}

			return `${passengerCount} passengers, ${dogCount} dogs`;
		});

		return { passengerCount };
	},
});
